import { CrudModelBase, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'
import { billingModalPatientSelectionGridColumnDefs } from '@/modules/billing-module/components/modal/patient/selection/billing-modal-patient-selection-grid.column-defs'

export type PatientSelectionModalState = CrudModelBase<PatientSearchResponse>
export const initialPatientSelectionModalState =
    (): PatientSelectionModalState => ({
        ...initialCrudModelBaseState(),
        columnsDef: billingModalPatientSelectionGridColumnDefs()
    })
